// @helpers
const { APIGet, APIPost, base64ToBlob } = require('utilities/APIRequestHelper');
const { download, base64ForPrint } = require('utilities/fileDownloadHelper');
const { capitalize } = require('utilities/stringHelper');
const BrowserUtils = require('utilities/browserUtils');
const { validRevolvingCardType } = require('utilities/APIParsingHelper');
const { getCardType } = require('utilities/cardsHelper');

// @vendors
const { isEmpty } = require('lodash');

// @constants
const actionTypes = require('constants/actionTypes');
const actionTypesCC = require('constants/contactCenter/actionTypes');
const { CHECK_LEGALES_ENABLED } = require('constants/flagBasedFeatures');
const { APLAZADO_TIN } = require('constants/AFISimulator.js');
const {
    NOT_ALLOWED_PRODUCT_CONTRACT_TNC_EMAIL_COUNTRIES,
} = require('constants/flagBasedFeatures');

const requestPDFRevolvingFetch = (type) => ({
    type: actionTypes[`REVOLVING_${type.toUpperCase()}_REQUEST`]
});

const requestPDFRevolvingSuccess = (type, response, temporaryDocumentId = null) => ({
    type: actionTypes[`REVOLVING_${type.toUpperCase()}_SUCCESS`],
    payload: {
        response,
        temporaryDocumentId
    }
});

const requestPDFRevolvingError = (type, error) => ({
    type: actionTypes[`REVOLVING_${type.toUpperCase()}_ERROR`],
    payload: {
        error
    }
});

const downloadRevolvingPDFeSuccess = (type) => ({
    type: actionTypes[`REVOLVING_${type.toUpperCase()}_DOWNLOAD_SUCCESS`],
});

const downloadRevolvingPDFError = (type) => ({
    type: actionTypes[`REVOLVING_${type.toUpperCase()}_DOWNLOAD_ERROR`]
});

const setDocumentInneReaded = (value) => ({
    type: actionTypes.REVOLVING_INNE_DOCUMENT_READED,
    payload: {
        readed: value
    }
});

const sendPreContractualDocumentMailRequest = () => ({
    type: actionTypes.REVOLVING_SEND_PRECONTRACTUAL_DOCUMENT_MAIL_REQUEST
});

const sendPreContractualDocumentMailSuccess = () => ({
    type: actionTypes.REVOLVING_SEND_PRECONTRACTUAL_DOCUMENT_MAIL_SUCCESS
});

const sendPreContractualDocumentMailFailure = (error) => ({
    type: actionTypes.REVOLVING_SEND_PRECONTRACTUAL_DOCUMENT_MAIL_ERROR,
    payload: {
        error,
    }
});

const mailPreContractualToClientSuccess = () => ({
    type: actionTypesCC.PRE_CONTRACTUAL_MAIL_SENT_SUCCESS
});

const mailPreContractualToClientRequest = () => ({
    type: actionTypesCC.PRE_CONTRACTUAL_MAIL_SENT_REQUEST
});

const mailPreContractualToClientFailure = error => ({
    type: actionTypesCC.PRE_CONTRACTUAL_MAIL_SENT_FAILURE,
    payload: {
        error
    }
});

const termsAndCondsInfoRequest = () => ({
    type: actionTypes.REVOLVING_TERMS_AND_CONDS_REQUEST,
});

const termsAndCondsInfoSuccess = () => ({
    type: actionTypes.REVOLVING_TERMS_AND_CONDS_SUCCESS,
});

const termsAndCondsInfoFailure = error => ({
    type: actionTypes.REVOLVING_TERMS_AND_CONDS_FAILURE,
    payload: {
        error,
    }
});

const setTermsAndCondsText = text => ({
    type: actionTypes.REVOLVING_TERMS_AND_CONDS_SET_TEXT,
    payload: {
        text,
    }
});

const setAFIParams = (params) => ({
    type: actionTypes.REVOLVING_SET_AFI_PARAMS,
    payload: {
        params,
    }
});

const setInneParams = (params) => ({
    type: actionTypes.REVOLVING_SET_INNE_PARAMS,
    payload: {
        params,
    }
});

const resetRevolvingProcess = () => ({
    type: actionTypes.REVOLVING_RESET_PROCESS
});


const requestRevolvingInsuranceUrlFetch = () => ({
    type: actionTypes.REVOLVING_INSURANCE_URL_FETCHING
});

const requestRevolvingInsuranceUrlSuccess = (response) => ({
    type: actionTypes.REVOLVING_INSURANCE_URL_SUCCESS,
    payload: {
        response,
    }
});

const requestRevolvingInsuranceUrlError = (error) => ({
    type: actionTypes.REVOLVING_INSURANCE_URL_ERROR,
    payload: {
        error
    }
});

const requestAfiInformationFetch = () => ({
    type: actionTypes.REVOLVING_AFI_INFORMATION_FETCHING
});

const requestAfiInformationSuccess = (response) => ({
    type: actionTypes.REVOLVING_AFI_INFORMATION_SUCCESS,
    payload: {
        response,
    }
});

const requestAfiInformationError = (error) => ({
    type: actionTypes.REVOLVING_AFI_INFORMATION_ERROR,
    payload: {
        error
    }
});

const requestAfiInformationReset = () => ({
    type: actionTypes.REVOLVING_AFI_INFORMATION_RESET,
});

const getInterest = (creditType, type, immGlobalVariables, immHireCardRevolving) => {
    const values = {
        'DIAMOND_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', type]),
        'OPEN_CREDIT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', type]),
        'PREMIUM_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', type]),
        'REVOLVING_CARD': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${immHireCardRevolving.get('pack')}`, type]),
        'VIAT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', type]),
    };

    return values[creditType];
}

const requestRevolvingDocument = (type, precontractualMailProductInfo, showRevolvingDocument, amount) => (dispatch, getState) => {
    let params = {
        header: {
            accept: 'application/json'
        }
    };
     const endpoint = `revolving${capitalize(type)}PDF`;
    const isInne = type === 'inne';
    let typeAPi = APIGet;

    if (isInne) {
        typeAPi = APIPost;
        const revolvingPersistentData = getState().revolvingPersistentData;
        params.query = {
            amount,
            product: {
                standard: precontractualMailProductInfo.standard,
                subtype: precontractualMailProductInfo.subproducto,
                type: precontractualMailProductInfo.producto
            }
        };
        if (getState().flagBasedFeatures.get('revolving_v2_ine') && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)) {
            const cardType = getCardType(getState().cards);
            const immGlobalVariables = getState().globalVariables;
            const immHireCardRevolving = getState().hireCardRevolving;
            const tin = getInterest(cardType, APLAZADO_TIN, immGlobalVariables, immHireCardRevolving);
            const tae = revolvingPersistentData.getIn(['paramsInne', 'tae']);
            params.header = {
                version: 2
            };

            if(!showRevolvingDocument) {
                params.query.dataAfiSimulator = {
                    calculationType: 3,
                    interestRate: Number(tin.replace(/%/g, '').replace(',', '.')) / 100,
                };
                params.query.tae = tae;
            }
        }
        if (showRevolvingDocument) {
            const calculationType = revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
            const interestRate = revolvingPersistentData.getIn(['paramsAFI', 'interestRate']);
            const typePayment = revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
            const valuePayment = revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
            const tae = revolvingPersistentData.getIn(['paramsInne', 'tae']);
            params.query.dataAfiSimulator = {
                calculationType,
                interestRate,
                returnFlows: false,
            };

            params.query.dataAfiSimulator[typePayment.charAt(0).toLowerCase() + typePayment.slice(1)] = valuePayment;
            params.query.paymentMethod = params.query.dataAfiSimulator.fixedPaymentAmount ? 'FIXED' : 'VARIABLE'
            params.query.tae = tae;
        } else {
            params.query.paymentMethod = 'UNIQUE'
        }
    } else {
        params.query = {
            standard: precontractualMailProductInfo.standard,
            subtype: precontractualMailProductInfo.subproducto,
            type: precontractualMailProductInfo.producto
        }
    }

    dispatch(requestPDFRevolvingFetch(type));
    return typeAPi({
        dispatch,
        endpoint,
        params
    })
        .then((response) => {
            if (isInne) {
                const { ineDocument: base64, temporaryDocumentId } = response;
                const contentType = 'application/pdf'
                const base64string = `data:${contentType};base64,${base64}`;
                const base64Document = {
                    base64string,
                    base64,
                    contentType
                }
                dispatch(requestPDFRevolvingSuccess(type, base64Document, temporaryDocumentId))
            } else {
                const { base64, mimeType: contentType } = response;
                const base64string = `data:${contentType};base64,${base64}`;
                const base64Document = {
                    base64string,
                    base64,
                    contentType
                }
                dispatch(requestPDFRevolvingSuccess(type, base64Document))
            }
        })
        .catch((error) => {
            dispatch(requestPDFRevolvingError(type, error))
        });
}

const requestAfiInformation = (amount) => (dispatch, getState) => {
    const revolvingPersistentData = getState().revolvingPersistentData;
    const calculationType = revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
    const interestRate = revolvingPersistentData.getIn(['paramsAFI', 'interestRate']);
    const typePayment = revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
    const valuePayment = revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
    let requestData = {
        query: {
            amount,
            calculationType,
            interestRate,
            returnFlows: false
        }
    };

    requestData.query[typePayment.charAt(0).toLowerCase() + typePayment.slice(1)] = valuePayment;

    dispatch(requestAfiInformationFetch());
    return APIPost({
        dispatch,
        endpoint: 'revolvingAfiIframe',
        params: requestData
    })
        .then((response) => {
            dispatch(requestAfiInformationSuccess(response));
        })
        .catch((response) => {
            if (!!response.error) {
                dispatch(requestAfiInformationError(response.error.status));
            } else {
                throw response;
            }
        });
}

const requestRevolvingInsuranceUrl = (requestObj) => (dispatch) => {

    const { standard, subproducto, producto } = requestObj;

    const requestData = {
        query: {
            product: {
                standard: standard,
                subtype: subproducto,
                type: producto
            }
        }
    };

    dispatch(requestRevolvingInsuranceUrlFetch());
    return APIPost({
        dispatch,
        endpoint: 'revolvingInsuranceUrl',
        params: requestData
    })
        .then((response) => {
            dispatch(requestRevolvingInsuranceUrlSuccess(response['insuranceUrl']));
        })
        .catch((response) => {
            if (!!response.error) {
                dispatch(requestRevolvingInsuranceUrlError(response.error.description));
            } else {
                throw response;
            }
        });
}

const downloadRevolvingPDF = (type, pdfFileName) => (dispatch, getState) => {
    const revolvingDocumentsPdfs = getState().revolvingDocumentsPdfs;
    const base64string = revolvingDocumentsPdfs.getIn([`${type}PDF`, 'base64string']);

    if (!!base64string) {
        const b64toBlobResponse = base64ToBlob(base64string);
        download(b64toBlobResponse, pdfFileName, 'application/pdf');
        dispatch(downloadRevolvingPDFeSuccess(type));
    }
    else {
        dispatch(downloadRevolvingPDFError(type));
    }
}

const onPrintRevolvingDocument = (type) => (dispatch, getState) => {
    const revolvingDocumentsPdfs = getState().revolvingDocumentsPdfs;
    const base64 = revolvingDocumentsPdfs.getIn([`${type}PDF`, 'base64']);
    const currentBlob = base64ForPrint(base64);

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(currentBlob);
    } else {
        const blobURL = window.URL.createObjectURL(currentBlob);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const sendPrecontractualDocumentMail = (precontractualMailProductInfo, forceEmailSending) => (dispatch, getState) => {
    const isProductContractEmailEnabled = getState().flagBasedFeatures.get(NOT_ALLOWED_PRODUCT_CONTRACT_TNC_EMAIL_COUNTRIES);
    const isMailSent = getState().revolvingDocumentsPdfs.get('precontractualMailSent');

    let requestData = {
        query: precontractualMailProductInfo,
    };

    // 1st we check the feature flag and only if it's turned on we continue with the logic.
    // If forceEmailSending is true we send the email. That flag is set to true for promotion codes in Checking and Payroll Accounts (for example)
    // If the email was already sent for this operative we don't send it again (going back and forth one or more steps).
    if (isProductContractEmailEnabled && (forceEmailSending || !isMailSent)) {
        dispatch(__CONTACT_CENTER__ ? mailPreContractualToClientRequest() : sendPreContractualDocumentMailRequest());

        return APIPost({
            dispatch,
            endpoint: 'revolvingSendPrecontractualDocumentMail',
            params: requestData
        })
            .then(() => dispatch(__CONTACT_CENTER__ ? mailPreContractualToClientSuccess() : sendPreContractualDocumentMailSuccess()))
            .catch(response => {
                if (!!response.error) {
                    dispatch(__CONTACT_CENTER__ ? mailPreContractualToClientFailure(response.error) : sendPreContractualDocumentMailFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

const setTermsAndCondsInfoRevolving = (contractType, products, contractNumber) => (dispatch, getState) => {
    const termsAndCondsCountryFlags = getState().flagBasedFeatures.get(CHECK_LEGALES_ENABLED);
    const revolvingPersistentData = getState().revolvingPersistentData;
    const textInne = revolvingPersistentData.get('textCheckInne');
    const textRevolving = revolvingPersistentData.get('textCheckRevolving');
    const temporaryDocumentId = revolvingPersistentData.get('temporaryDocumentId');

    if (termsAndCondsCountryFlags && !!textInne && !!contractNumber && !!contractType && !isEmpty(products)) {
        dispatch(termsAndCondsInfoRequest());

        let documentReadDto = [
            {
                acceptedText: textInne,
                revolvingDocumentType: 'INE'
            }
        ];

        if (textRevolving) {
            documentReadDto = [
                ...documentReadDto,
                {
                    acceptedText: textRevolving,
                    revolvingDocumentType: 'REVOLVING_DOCUMENT'
                }
            ]
        }

        const requestData = {
            query: {
                documentReadDto,
                productInformation: {
                    contractNumber,
                    productName: contractType,
                    temporaryDocumentId,
                    product: {
                        subtype: products[0].subType, // We needed to change this name from subType to subtype avoiding the camelcase
                        standard: products[0].standard,
                        type: products[0].type,
                    }
                }
            }
        };

        return APIPost({
            dispatch,
            endpoint: 'termsAndCondsRevolving',
            params: requestData,
        })
            .then(() => dispatch(termsAndCondsInfoSuccess()))
            .catch(response => {
                if (!!response.error) {
                    dispatch(termsAndCondsInfoFailure(response.error));
                } else {
                    throw response;
                }
            }
            );
    }
};

module.exports = {
    requestRevolvingDocument,
    downloadRevolvingPDF,
    onPrintRevolvingDocument,
    requestRevolvingInsuranceUrl,
    requestAfiInformation,
    requestAfiInformationReset,
    setDocumentInneReaded,
    sendPrecontractualDocumentMail,
    setAFIParams,
    setInneParams,
    setTermsAndCondsInfoRevolving,
    setTermsAndCondsText,
    resetRevolvingProcess
};
